export function sendResizeWindowEvent() {
    setTimeout(
        function() {
            const event = document.createEvent('Event');
            event.initEvent('resize', false, true);
            (window as Window).dispatchEvent(event);
        },
        0
    );
}